import React from 'react';
import styled from 'styled-components';
import SocialLinks from './SocialLinks';
import ScrollReveal from './ScrollReveal';

const FooterContainer = styled.footer`
  background-color: #1a1a1a;
  color: #ffffff;
  padding: 4rem 1rem 2rem;
  margin-top: 5rem;

  @media (max-width: 768px) {
    padding: 2rem 1rem 1rem;
    margin-top: 2rem;
  }

  @media (max-width: 480px) {
    padding: 1.5rem 1rem 0.75rem;
    margin-top: 1.5rem;
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2.5rem;
  margin-bottom: 3rem;

  @media (max-width: 968px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 2rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
    text-align: center;
  }

  @media (max-width: 480px) {
    gap: 1rem;
    margin-bottom: 1rem;
  }
`;

const FooterSection = styled.div`
  h3 {
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
    color: #ffffff;

    @media (max-width: 768px) {
      font-size: 1rem;
      margin-bottom: 1rem;
      text-align: center;
    }

    @media (max-width: 480px) {
      font-size: 0.9rem;
      margin-bottom: 0.75rem;
    }
  }

  a {
    color: rgba(255, 255, 255, 0.7);
    text-decoration: none;
    display: block;
    margin-bottom: 0.5rem;
    transition: color 0.3s ease;
    font-size: 0.95rem;
    min-height: 44px;
    display: flex;
    align-items: center;
    touch-action: manipulation;

    &:hover {
      color: #007bff;
    }

    @media (max-width: 768px) {
      justify-content: center;
      font-size: 0.875rem;
      margin-bottom: 0.5rem;
      min-height: 40px;
    }

    @media (max-width: 480px) {
      font-size: 0.8rem;
      margin-bottom: 0.4rem;
      min-height: 36px;
    }
  }

  i {
    margin-right: 0.5rem;

    @media (max-width: 768px) {
      margin-right: 0.4rem;
    }
  }
`;

const QuickLinksContainer = styled.div`
  display: block;

  @media (max-width: 480px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem 0.15rem;
    column-gap: 0.15rem;
  }
`;

const QuickLinksLeft = styled.div`
  display: block;

  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const QuickLinksRight = styled.div`
  display: block;

  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const SocialLinksWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 2rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    margin-top: 1rem;
    gap: 1.5rem;
  }

  @media (max-width: 480px) {
    margin-top: 0.75rem;
    gap: 1.25rem;
  }

  a {
    color: rgba(255, 255, 255, 0.7);
    font-size: 1.5rem;
    transition: color 0.3s ease;
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    touch-action: manipulation;

    &:hover {
      color: #007bff;
    }

    @media (max-width: 768px) {
      font-size: 1.25rem;
      min-width: 40px;
      min-height: 40px;
    }

    @media (max-width: 480px) {
      font-size: 1.1rem;
      min-width: 36px;
      min-height: 36px;
    }
  }
`;

const CopyrightText = styled.div`
  text-align: center;
  margin-top: 2rem;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.9rem;

  @media (max-width: 768px) {
    margin-top: 1rem;
    font-size: 0.85rem;
  }

  @media (max-width: 480px) {
    margin-top: 0.75rem;
    font-size: 0.75rem;
  }
`;

function Footer() {
  return (
    <FooterContainer>
      <FooterContent>
        <ScrollReveal direction="blur" delay="0.1s" duration="0.9s">
        <FooterGrid>
          <FooterSection>
            <h3>Quick Links</h3>
            <QuickLinksContainer>
              <QuickLinksLeft>
            <a href="/">Home</a>
            <a href="#about">About</a>
              </QuickLinksLeft>
              <QuickLinksRight>
            <a href="#projects">Projects</a>
            <a href="#certificates">Certificates</a>
              </QuickLinksRight>
            </QuickLinksContainer>
          </FooterSection>
          <FooterSection>
            <h3>Contact</h3>
            <a href="mailto:kabilmbarki88@gmail.com">
              <i className="fas fa-envelope"></i> kabilmbarki88@gmail.com
            </a>
            <a href="https://wa.me/21628514338" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-whatsapp"></i> +21628514338
            </a>
          </FooterSection>
          <FooterSection>
            <h3>Follow Me</h3>
            <SocialLinksWrapper>
              <SocialLinks />
            </SocialLinksWrapper>
          </FooterSection>
        </FooterGrid>
        </ScrollReveal>
        <CopyrightText>
          &copy; {new Date().getFullYear()} Kabil Mbarki — KaTEK. All rights reserved.
        </CopyrightText>
      </FooterContent>
    </FooterContainer>
  );
}

export default Footer;
